'use client';

import './index.css';

import { Cross2Icon } from '@radix-ui/react-icons';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { Image } from '@/components/image';

import { isImage } from '@/helpers/image';

import { AutoForm } from '../auto-form';

export const AutoPopup = ({ story }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const storedValue = localStorage?.getItem?.(`form:${story.uuid}`) || '';

    if (storedValue === 'submitted') {
      return;
    }

    const timeout = setTimeout(
      () => {
        setShow(true);
      },
      (story.content.showDelay || 5) * 1000,
    );

    return () => clearTimeout(timeout);
  }, []);

  const form = story.content.form?.[0];

  const handleClose = () => {
    setShow(false);

    localStorage?.setItem?.(`form:${story.uuid}`, 'submitted');
  };

  return show ? (
    <div className="auto-popup">
      <div className="auto-popup__dialog">
        {isImage(story.content.image) ? (
          <div className="auto-popup__image">
            <Image
              image={story.content.image}
              draggable="false"
              sizes="400px"
            />
          </div>
        ) : null}

        <div className={classNames('auto-popup__title', 'mobile-only')}>
          {story.content.titleOnMobile}
        </div>

        <div className="auto-popup__form">
          {form ? <AutoForm form={form} onSuccess={handleClose} /> : null}
        </div>

        <button
          type="button"
          className="auto-popup__close"
          onClick={handleClose}
        >
          <Cross2Icon />
        </button>
      </div>
    </div>
  ) : null;
};
